function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/**
 * Format a number representing currency.
 *
 * @param {number} num
 * @param {string} [locale=en_US] Language code string representing locale
 * @param {boolean} [showFractionDigits=false]
 * @returns {string}
 */
function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var showFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof Intl === 'undefined' || !Intl.NumberFormat) {
    return num.toString();
  }

  var options = {
    style: 'currency',
    currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
  };
  var currencyValue;

  if (typeof num !== 'number') {
    // eslint-disable-next-line no-console
    console.warn("formatCurrency: unexpected currency value: ".concat(num, " of type ").concat(_typeof(num)));
    return '';
  }

  if (showFractionDigits) {
    // two fraction digits (aka decimal places) by default
    currencyValue = num;
  } else {
    currencyValue = Math.round(num);
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(currencyValue);
}
/**
 * Format a number representing a number.
 *
 * @param {number} num
 * @param {string} [locale=en_US] Language code string representing locale
 * @returns {string}
 */

function formatNumber(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

  if (typeof Intl === 'undefined' || !Intl.NumberFormat) {
    return num.toString();
  }

  if (typeof num !== 'number') {
    return '';
  }

  return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}
/**
 * Format a string, Date, or number representing a date.
 *
 * @param {number | string | Date} d Date
 * @param {string} [locale=en_US] language code string representing locale
 * @param {object} [options={}] Options for Intl.DateTimeFormat
 * @returns {string}
 */

function formatDate(d) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) {
    return d.toString();
  }

  var date;

  if (d instanceof Date) {
    date = d;
  } else if (typeof d === 'string' || Number.isInteger(d)) {
    date = new Date(d);
  }

  if (date && Number.isFinite(date.getTime())) {
    return new Intl.DateTimeFormat(locale.replace('_', '-'), options).format(date);
  }

  return '';
}

export { formatCurrency, formatDate, formatNumber };
//# sourceMappingURL=es.js.map
